import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cielo-forgot-password',
  templateUrl: './cielo-forgot-password.component.html',
  styleUrls: ['./cielo-forgot-password.component.scss']
})
export class CieloForgotPasswordComponent {
  @Input() scope;
}
